import { useEffect, useState } from "react";
import { apiRequest } from "./api";
import type { ExchangeState } from "./types";

export function useExchangeState(pollMilliseconds = 60_000) {
  const [exchange, setExchange] = useState<ExchangeState | null>(null);

  useEffect(() => {
    let active = true;
    const loadExchange = () => {
      apiRequest<{ exchange: ExchangeState }>("/api/exchange")
        .then((response) => { if (active) setExchange(response.exchange); })
        .catch(console.error);
    };
    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") loadExchange();
    };

    loadExchange();
    const timer = window.setInterval(loadExchange, pollMilliseconds);
    document.addEventListener("visibilitychange", refreshWhenVisible);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
    };
  }, [pollMilliseconds]);

  return exchange;
}
